let isRefreshing = false;
let refreshPromise = null;

export const withTokenRefresh = async (requestFn, refreshFn) => {
  try {
    return await requestFn();
  } catch (error) {
    const status = error?.response?.status;
    if (status !== 401) throw error;

    if (!isRefreshing) {
      isRefreshing = true;
      refreshPromise = refreshFn().finally(() => {
        isRefreshing = false;
      });
    }
    await refreshPromise;
    return requestFn();
  }
};
